<div *ngIf="!isLoading" class="repair-order ml-4 mr-4 pdf-font-{{ company?.appsettings?.pdfFontSize }}">
  <table class="width-100p">
    <thead class="report-header">
      <div class="repair-order-header">
        <!-- Company Details -->

        <!-- PDF LOGO -->
        <div class="repair-order-company pdfLogo-enable" *ngIf="company?.pdfLogo">
          <div class="repair-order-logo pr-3 align-self-start">
            <img [ngClass]="pdfLogoType" class="company-logo" [src]="company?.pdfLogo" [alt]="company?.name" />
          </div>
        </div>

        <!-- Default logo -->
        <div class="repair-order-company d-flex" *ngIf="!company?.pdfLogo">
          <div class="repair-order-logo pr-3 align-self-start">
            <img class="company-logo" [src]="company?.logo" [alt]="company?.name" />
          </div>
          <div class="repair-order-details flex-column">
            <span class="font-bold dynamicFont">{{ company?.name }}</span>
            <span>{{ company?.phone | mask: '(000) 000-0000' }}</span>
            <span>{{ company?.email }}</span>
            <span>{{ company.formattedAdress }} </span>
            <span *ngIf="company.regNumber && company.regNumber.includes(':')"
              [innerHTML]="this.helperService.formatRegNumber(company?.regNumber)"> </span>
            <span *ngIf="company.regNumber && !company.regNumber.includes(':')"> Business/GST#: {{ company?.regNumber }}
            </span>
          </div>
        </div>

        <!-- Estimate Details -->
        <div class="repair-order-title text-right width-320">
          <p class="mb-1 order-status-title font-600">
            <span class="capitalize" *ngIf="order?.orderStatus !== 'invoice' && order?.orderStatus !== 'estimate'">{{
              order?.orderStatus }} #
              {{ order?.code }}
            </span>
            <span class="capitalize" *ngIf="order?.orderStatus === 'estimate'">{{ 'technician.estimate' | translate }} #
              {{ order?.code }}
            </span>
            <span class="capitalize" *ngIf="order?.orderStatus === 'invoice'">{{ 'invoice.invoice' | translate }} #
              {{ order?.orderStatus === 'invoice' && order?.invCode ? order?.invCode : order?.code }}
            </span>
          </p>
          <p class="m-0 dynamicFont estimate-against" *ngIf="order?.orderStatus === 'invoice'">{{
            'invoice.against-estimate' | translate }}#: {{ order?.code }}</p>
          <p class="m-0 dynamicFont created-date">
            <!-- WHEN BETA FLAG ON -->
            <span *ngIf="isFloridaStateComplianceUpdates">{{ 'invoice.created' | translate }}: {{ order?.createdAt |
              date: 'MMM d, y h:mm a' }}</span>
            <!-- WHEN BETA FLAG OFF -->
            <span *ngIf="!isFloridaStateComplianceUpdates">{{ 'invoice.created' | translate }}: {{ order?.createdAt |
              date: 'MMM d, yyyy' }}</span>
          </p>
          <p class="m-0 dynamicFont invoiced-date" *ngIf="order?.orderStatus === 'invoice'">
            <!-- WHEN BETA FLAG ON -->
            <span *ngIf="isFloridaStateComplianceUpdates">{{ 'invoice.invoiced' | translate }}: {{ order?.invoiceDate |
              date: 'MMM d, y h:mm a' }}</span>
            <!-- WHEN BETA FLAG OFF -->
            <span *ngIf="!isFloridaStateComplianceUpdates">{{ 'invoice.invoiced' | translate }}: {{ order?.invoiceDate |
              date: 'MMM d, yyyy' }}</span>
          </p>
          <p class="m-0 dynamicFont service-advisor"
            *ngIf="order.displayServiceWriter && order.serviceWriter && order.serviceWriter.name">
            {{ 'invoice.service-advisor' | translate }}: {{ order.serviceWriter && order.serviceWriter.name }}
          </p>
        </div>
      </div>
    </thead>
    <tbody class="report-body" *ngIf="order.displayServiceWriter && order.serviceWriter && order.serviceWriter.name">
      <tr style="height: 25px"></tr>
    </tbody>
    <tbody class="report-body">
      <tr>
        <div class="repair-order-customer mt-2">
          <div class="repair-order-left flex-column align-self-start dynamicFont">
            <span class="font-bold">{{ customer?.useDriverDetailOnInvoice && vehicle?.driver ? vehicle?.driver?.fullName
              + (vehicle?.driver?.companyName ? ' | ' + vehicle?.driver?.companyName : '') : customer?.fullName ||
              customer?.displayName }}</span>
            <span class="font-bold" *ngIf="customer?.companyName && !customer?.isFleetCustomer">
              {{ customer?.companyName }}
            </span>
            <span>{{ customer?.useDriverDetailOnInvoice && vehicle?.driver ?
              (vehicle?.driver?.phone | mask: '(000) 000-0000') : (customer?.phone | mask: '(000) 000-0000') }}</span>
            <span>{{ customer?.useDriverDetailOnInvoice && vehicle?.driver ? vehicle?.driver?.email : customer?.email
              }}</span>
            <span>{{ customer?.useDriverDetailOnInvoice && vehicle?.driver ? vehicle?.driver?.address :
              customer?.address }}</span>
          </div>

          <div class="repair-order-right flex-column dynamicFont text-left">
            <span class="font-bold">{{ vehicle?.vehicleName ? vehicle?.vehicleName : vehicle?.name }}</span>

            <div class="car-info-wrapper">
              <div class="car-info-heading">{{ 'invoice.VIN' | translate }}:</div>
              <div class="car-info-content">&nbsp;<span [innerHTML]="vehicle?.VIN | highlightVin"></span></div>
            </div>

            <div class="car-info-wrapper">
              <div class="car-info-heading">{{ 'invoice.mileage' | translate }}{{ isTrackMileageInAndOut ? ' in' : ''
                }}:</div>
              <div class="car-info-content">
                &nbsp;{{ milage?.reading || 0 }} <span *ngIf="milage?.mileageMeasuringUnit">{{
                  milage?.mileageMeasuringUnit === 'mi' ? 'miles' : 'km' }}</span>
              </div>
            </div>

            <div class="car-info-wrapper" *ngIf="order?.orderStatus === 'invoice' && isTrackMileageInAndOut">
              <div class="car-info-heading">{{ 'invoice.mileage-out' | translate }}:</div>
              <div class="car-info-content">
                &nbsp;{{ mileageOut?.reading || 0 }}
                <span *ngIf="mileageOut?.mileageMeasuringUnit">
                  {{ mileageOut?.mileageMeasuringUnit === 'mi' ? 'miles' : 'km' }}
                </span>
              </div>
            </div>

            <div class="car-info-wrapper">
              <div class="car-info-heading">{{ 'invoice.license-plate' | translate }}:</div>
              <div class="car-info-content">&nbsp;{{ vehicle?.licensePlateNo }}</div>
            </div>
          </div>
        </div>
      </tr>

      <tr *ngIf="order?.customerNotes">
        <div class="repair-order-notes service-card">
          <div class="s-card-header">
            <!-- WHEN BETA FLAG ON -->
            <span *ngIf="isFloridaStateComplianceUpdates">{{ 'customer-concerns-&-recommendation' | translate }}</span>
            <!-- WHEN BETA FLAG OFF -->
            <span *ngIf="!isFloridaStateComplianceUpdates">{{ 'customer-notes' | translate }}</span>
          </div>
          <div class="s-card-body">
            <p class="mb-0 text-break" style="white-space: pre-line" [innerHTML]="order?.customerNotes"></p>
          </div>
        </div>
      </tr>

      <tr *ngIf="!isDvi2Enabled && concerns && concerns.length && isCustomerConcernEnabled">
        <div class="repair-order-notes service-card" *ngFor="let concern of concerns; let i = index">
          <div class="py-2 s-card-header">
            <img src="assets/img/customer-concern.svg" class="pr-1 mb-1 customer-concern-icon" alt="" />
            <span>{{ getConcernType('label', concern) }} #{{ concern?.concernNumber || i + 1 }}</span>
          </div>
          <div class="s-card-body">
            <p class="mb-0 text-break py-3" style="white-space: pre-line" [innerHTML]="concern?.notes"></p>
          </div>

          <div *ngFor="let service of order?.services">
            <ng-container *ngIf="isServiceLinked(concern, service)">
              <app-repair-order-item [service]="service" [total]="order.total"
                [isWarrantyNumberAddonEnabled]="isWarrantyNumberAddonEnabled" [currentLang]="currentLang"
                [isPartWarrantiesEnabled]="isPartWarrantiesEnabled"
                [isFlatRateSubItemVisibleToCust]="isFlatRateSubItemVisibleToCust"
                [isFlatRateSubItemDescVisibleToCust]="isFlatRateSubItemDescVisibleToCust"
                [isEnhancedTSEnabled]="isEnhancedTSEnabled"
                [isFlatRateSubItemQtyVisibleToCust]="isFlatRateSubItemQtyVisibleToCust"
                [isTreadDepthVisibleOnInvoice]="isTreadDepthVisibleOnInvoice"
                [displayExternalServiceNotes]="displayExternalServiceNotes" [serviceAuthLabel]="serviceAuthLabel"
                [isDeferredServiceEnabled]="isDeferredServiceEnabled" [appSettings]="company?.appsettings"
                [shopAppSettings]="shopAppSettings" [isTireStorage2Enabled]="isTireStorage2Enabled">
              </app-repair-order-item>
            </ng-container>
          </div>
        </div>
      </tr>

      <tr *ngIf="isDvi2Enabled && concerns && concerns.length && isCustomerConcernEnabled">
        <ng-container *ngFor="let concern of concerns; let i = index">
          <div class="repair-order-notes service-card">
            <div class="py-2 s-card-header">
              <img [src]="getConcernType('icon', concern)" style="height: 25px" class="pr-1 mb-1" alt="" />
              <!-- <span>{{ getConcernType('label', concern) }} #{{ concern?.concernNumber || i + 1 }}</span> -->

              <span *ngIf="getConcernType('label', concern) === 'Customer Concern'">{{ 'concerns.customerConcern' |
                translate }} #{{ concern?.concernNumber || i + 1 }}</span>
              <span *ngIf="getConcernType('label', concern) === 'Safety Issue'">{{ 'concerns.safetyIssue' | translate }}
                #{{ concern?.concernNumber || i + 1 }}</span>
              <span *ngIf="getConcernType('label', concern) === 'Monitor for Time or Mileage'">{{
                'concerns.monitorTimeMileage' | translate }} #{{ concern?.concernNumber || i + 1 }}</span>
              <span *ngIf="getConcernType('label', concern) === 'While We Are Here...'">{{ 'concerns.whileHere' |
                translate }} #{{ concern?.concernNumber || i + 1 }}</span>
              <span *ngIf="getConcernType('label', concern) === 'Suggested Maintenance Items'">{{
                'concerns.maintainanceItem' | translate }} #{{ concern?.concernNumber || i + 1 }}</span>
              <span *ngIf="getConcernType('label', concern) === 'Cosmetic & Optional Items'">{{ 'concerns.cosmeticItem'
                | translate }} #{{ concern?.concernNumber || i + 1 }}</span>
            </div>
            <div class="s-card-body">
              <p class="mb-0 text-break py-3" style="white-space: pre-line" [innerHTML]="concern?.notes"></p>
            </div>
            <span *ngIf="concern?.findings?.length">
              <div class="py-2 s-card-header d-flex">
                <div class="col-md-9">{{'inspection-finding'|translate}}</div>
                <div class="col-md-3">{{'status'|translate}}</div>
              </div>

              <div *ngFor="let finding of concern?.findings" class="s-finding-card-body border-bottom-lightest">
                <div class="d-flex align-items-center row">
                  <div class="title-text d-flex align-items-center justify-content-between pr-0">
                    <div class="d-flex">
                      <span class="icon {{ finding?.iconClass }}-circle">
                        <i class="fal {{ finding?.class }}"></i>
                      </span>
                      <span class="pl-3 font-16 font-600">{{ helperService.getLocalizationValue(currentLang , finding , 'title') }}</span>
                    </div>
                    <div class="measurement">
                      <ng-container *ngFor="let item of finding.measurement">
                        <div class="issue-title" *ngIf="item.value && item.unit">
                          {{item.value}} {{ item.unit}}
                        </div>
                      </ng-container>
                    </div>
                  </div>
                  <div class="condition-text condition-text-print d-flex align-items-center">
                    <div *ngFor="let condition of finding.conditions">
                      <div class="issue-title mr-3">{{ helperService.getLocalizationValue(currentLang, condition, 'name') }}</div>
                    </div>
                  </div>
                  <div class="col-md-3 font-16 font-600" class="action-text">{{ finding?.actionText }}</div>
                </div>
                <p *ngIf="finding?.notes" class="pt-2 pl-3 font-16">{{ finding?.notes }}</p>
              </div>
            </span>

            <div *ngFor="let service of order?.services">
              <ng-container *ngIf="isServiceLinked(concern, service)">
                <app-repair-order-item [service]="service" [total]="order.total"
                  [isWarrantyNumberAddonEnabled]="isWarrantyNumberAddonEnabled" [currentLang]="currentLang"
                  [isPartWarrantiesEnabled]="isPartWarrantiesEnabled"
                  [isFlatRateSubItemVisibleToCust]="isFlatRateSubItemVisibleToCust"
                  [isFlatRateSubItemDescVisibleToCust]="isFlatRateSubItemDescVisibleToCust"
                  [isEnhancedTSEnabled]="isEnhancedTSEnabled"
                  [isFlatRateSubItemQtyVisibleToCust]="isFlatRateSubItemQtyVisibleToCust"
                  [isTreadDepthVisibleOnInvoice]="isTreadDepthVisibleOnInvoice"
                  [displayExternalServiceNotes]="displayExternalServiceNotes" [serviceAuthLabel]="serviceAuthLabel"
                  [isDeferredServiceEnabled]="isDeferredServiceEnabled" [appSettings]="company?.appsettings"
                  [shopAppSettings]="shopAppSettings" [isTireStorage2Enabled]="isTireStorage2Enabled">
                </app-repair-order-item>
              </ng-container>
            </div>
          </div>
        </ng-container>
      </tr>

      <div *ngFor="let service of order?.services">
        <ng-container *ngIf="!service.concernNumber">
          <app-repair-order-item [service]="service" [total]="order.total"
            [isWarrantyNumberAddonEnabled]="isWarrantyNumberAddonEnabled"
            [isPartWarrantiesEnabled]="isPartWarrantiesEnabled" [currentLang]="currentLang"
            [isFlatRateSubItemVisibleToCust]="isFlatRateSubItemVisibleToCust"
            [isFlatRateSubItemDescVisibleToCust]="isFlatRateSubItemDescVisibleToCust"
            [isEnhancedTSEnabled]="isEnhancedTSEnabled"
            [isFlatRateSubItemQtyVisibleToCust]="isFlatRateSubItemQtyVisibleToCust"
            [isTreadDepthVisibleOnInvoice]="isTreadDepthVisibleOnInvoice"
            [displayExternalServiceNotes]="displayExternalServiceNotes" [serviceAuthLabel]="serviceAuthLabel"
            [isDeferredServiceEnabled]="isDeferredServiceEnabled" [appSettings]="company?.appsettings"
            [shopAppSettings]="shopAppSettings" [isTireStorage2Enabled]="isTireStorage2Enabled">
          </app-repair-order-item>
        </ng-container>
      </div>

      <br />

      <tr>
        <!-- [ngClass]="[disclaimer?.length > 2000 || invDisclaimer?.length > 2000 ? 'flex-center-start' : 'flex-start-start']"  -->
        <div class="repair-order-footer position-relative">
          <!-- Start Payment Details -->
          <div class="disclaimer dynamicFont diclaimer-box-wrapper">
            <!-- Show payment details if all conditions met -->
            <div class="diclaimer-box-left">
              <!-- Starting leftBar -->
              <ng-container *ngIf="isPaymentSectionVisible">
                <div class="payment-detail-wrapper" #leftBar>
                  <div class="payment-detail-header header-bg">
                    <div class="payment-col date">
                      <span class="th">{{ 'date-and-time' | translate }}</span>
                    </div>

                    <div class="payment-col rec-no">
                      <span class="th">{{ 'receipt-no' | translate }}</span>
                    </div>

                    <div class="payment-col method">
                      <span class="th">{{ 'payment-method' | translate }}</span>
                    </div>

                    <div class="payment-col amount">
                      <span class="th">{{ 'amount' | translate }}</span>
                    </div>
                  </div>

                  <div class="payment-detail-body">
                    <div class="payment-detail-row" *ngFor="let payment of paymentHistory">
                      <div class="payment-col date">
                        <span class="td">{{ payment?.createdAt }}</span>
                      </div>

                      <div class="payment-col rec-no">
                        <span class="td">{{ payment?.code }}</span>
                      </div>

                      <div class="payment-col method">
                        <span class="td method-td-space">
                          {{ payment?.card4Digits ? 'Card - ' : '' }}{{payment?.paymentMethod?.name }}<ng-container
                            *ngIf="payment?.paymentType === 'cheque' && payment?.checkNo">#
                            {{payment?.checkNo}}</ng-container>
                        </span>
                      </div>

                      <div class="payment-col amount">
                        <span class="td">{{ payment?.amount | currency: usd }}</span>
                      </div>

                      <div *ngFor="let refund of payment?.refunds" class="payment-detail-row">
                        <div class="payment-col date">
                          <span class="td">{{ refund?.refundDate }}</span>
                        </div>

                        <div class="payment-col rec-no pl-15px">
                          <span class="td text-break">{{ 'refund' | translate }}</span>
                        </div>

                        <div class="payment-col method pl-0">
                          <span *ngIf="payment?.card4Digits && payment?.refunds">
                            xxxx-xxxx-{{ payment?.card4Digits }}
                            <br>
                            <span *ngIf="isGlobalPaymentEnabled && payment?.cardConfNo">
                              Auth code {{payment?.cardConfNo}}
                            </span>
                          </span>
                        </div>

                        <div class="payment-col amount">
                          <span class="td refund">-{{ refund?.amount | currency: usd }}</span>
                        </div>
                      </div>

                      <div class="payment-col date"></div>

                      <div class="payment-col rec-no pl-33px">
                        <span class="td" *ngIf="payment?.refunds && payment?.refunds?.length">Net Amount</span>
                      </div>

                      <div class="payment-col method">
                        <span *ngIf="payment?.card4Digits && payment?.refunds?.length === 0"> xxxx-xxxx-{{
                          payment?.card4Digits }}
                          <br>
                          <span *ngIf="isGlobalPaymentEnabled && payment?.cardConfNo">Auth code
                            {{payment?.cardConfNo}}</span>
                        </span>


                      </div>

                      <div class="payment-col amount">
                        <span *ngIf="payment?.refunds && payment?.refunds?.length" class="td bold-amount">
                          {{ payment?.amount - payment?.refundToDate | currency: usd }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
            <div class="diclaimer-box-right">
              <!-- Start Order Summary -->
              <div *ngIf="company?.appsettings?.isShowLineItemDisInPdf" class="ml-2 s-summary" #rightBar>
                <span *ngIf="serviceItemsBreakdown">
                  <!-- PTLO total -->
                  <div class="m-0 flex-start-center mb-2">
                    <p class="service-amount m-0 pr-1 s-summery-title font-bold">{{ 'service-amount' | translate }}</p>
                    <p class="b-bottom width-100p m-0"></p>
                    <p class="m-0 summary-content text-right font-bold">{{ renderTotalPLTO() | currency: usd }}</p>
                  </div>

                  <!-- Part -->
                  <div class="m-0 flex-start-center mb-2">
                    <p class="m-0 pl-4 pr-1 s-summery-title">{{ 'part' | translate }}</p>
                    <p class="b-bottom width-100p m-0"></p>
                    <p class="m-0 summary-content text-right">{{ order?.total?.parts || 0 | currency: usd }}</p>
                  </div>

                  <!-- Labor -->
                  <div class="m-0 flex-start-center mb-2">
                    <p class="m-0 pl-4 pr-1 s-summery-title">{{ 'labor' | translate }}</p>
                    <p class="b-bottom width-100p m-0"></p>
                    <p class="m-0 summary-content text-right">{{ order?.total?.labor || 0 | currency: usd }}</p>
                  </div>

                  <!-- Tire storage -->
                  <div class="m-0 flex-start-center mb-2" *ngIf="order?.total?.tireStorage">
                    <p class="m-0 pl-4 pr-1 s-summery-title">{{ 'tire-storage' | translate }}</p>
                    <p class="b-bottom width-100p m-0"></p>
                    <p class="m-0 summary-content text-right">{{ order?.total?.tireStorage || 0 | currency: usd }}</p>
                  </div>

                  <!-- Tire -->
                  <div class="m-0 flex-start-center mb-2" *ngIf="order?.total?.tire">
                    <p class="m-0 pl-4 pr-1 s-summery-title">{{ 'tire' | translate }}</p>
                    <p class="b-bottom width-100p m-0"></p>
                    <p class="m-0 summary-content text-right">{{ order?.total?.tire || 0 | currency: usd }}</p>
                  </div>

                  <!-- Sublet -->
                  <div class="m-0 flex-start-center mb-2" *ngIf="order?.total?.sublet">
                    <p class="m-0 pl-4 pr-1 s-summery-title">{{ 'sublet' | translate }}</p>
                    <p class="b-bottom width-100p m-0"></p>
                    <p class="m-0 summary-content text-right">{{ order?.total?.sublet || 0 | currency: usd }}</p>
                  </div>

                  <!-- Other -->
                  <div class="m-0 flex-start-center mb-2" *ngIf="order?.total?.other">
                    <p class="m-0 pl-4 pr-1 s-summery-title">{{ 'other' | translate }}</p>
                    <p class="b-bottom width-100p m-0"></p>
                    <p class="m-0 summary-content text-right">{{ order?.total?.other || 0 | currency: usd }}</p>
                  </div>
                </span>

                <div *ngIf="order.total.shopFee || order?.total?.hazmatFee || order?.total?.totalFee"
                  class="m-0 flex-start-center mb-2">
                  <p class="service-amount m-0 pr-1 s-summery-title font-bold">{{ 'add' | translate }}: {{ 'fees' |
                    translate }}</p>
                  <p class="b-bottom width-100p m-0"></p>
                  <p class="m-0 summary-content text-right font-bold">
                    {{ order?.total?.hazmatFee + order?.total?.totalFee || 0 | currency: usd }}
                  </p>
                </div>

                <!-- Service Fee Items -->
                <div *ngFor="let serviceFee of order?.total?.serviceLevelFeeItems" class="m-0 flex-start-center mb-2"
                  [hidden]="!order.total.hazmatFee">
                  <p style="white-space: nowrap" class="m-0 pl-4 pr-1 s-summery-title capitalize"
                    [innerHTML]="helperService.getLocalizationValue(currentLang,serviceFee, 'title')">
                  </p>
                  <p class="b-bottom width-100p m-0"></p>
                  <p class="m-0 summary-content text-right">
                    {{ serviceFee?.subTotal || 0 | currency: usd }}
                  </p>
                </div>

                <!-- Order Fee Items -->
                <ng-container *ngIf="order.isRoLevelFeeEnabled">
                  <div *ngFor="let feeItem of order?.total?.preTaxFee" class="m-0 flex-start-center mb-2">
                    <p class="m-0 pl-4 s-summery-title"
                      [innerHTML]="helperService.getLocalizationValue(currentLang,feeItem, 'name')">
                    </p>
                    <p class="b-bottom width-100p m-0"></p>
                    <p class="m-0 summary-content text-right">
                      {{ feeItem?.feeCalcValue || 0 | currency: usd }}
                    </p>
                  </div>
                </ng-container>

                <!-- Shop supplies -->
                <div class="m-0 flex-start-center mb-2" *ngIf="!order?.isRoLevelFeeEnabled && order?.total?.shopFee">
                  <p class="m-0 s-summery-title">{{ 'shop-supplies' | translate }}</p>
                  <p class="b-bottom width-100p m-0"></p>
                  <p class="m-0 summary-content text-right">
                    {{ order?.total?.shopFee || 0 | currency: usd }}
                  </p>
                </div>

                <!-- Flat Rate Fee Items -->
                <div *ngFor="let flatRateFee of flatRateFee" [hidden]="flatRateFee && flatRateFee.length === 0"
                  class="m-0 flex-start-center mb-2">
                  <p style="white-space: nowrap" class="m-0 pl-4 pr-1 s-summery-title capitalize"
                    [innerHTML]="helperService.getLocalizationValue(currentLang,flatRateFee, 'title')">
                  </p>
                  <p class="b-bottom width-100p m-0"></p>
                  <p class="m-0 summary-content text-right">
                    {{ flatRateFee?.subTotal || 0 | currency: 'USD' }}
                  </p>
                </div>

                <div
                  *ngIf="order?.total?.serviceLevelDiscount || order?.total?.discountedAmount || order?.total?.itemLevelDiscount"
                  class="m-0 flex-start-center mb-2">
                  <p class="service-amount m-0 pr-1 s-summery-title font-bold">{{ 'less-discount' | translate }}</p>
                  <p class="b-bottom width-100p m-0"></p>
                  <p class="m-0 summary-content text-right font-bold">
                    {{ order?.total?.discountedAmount + order?.total?.itemLevelDiscount +
                    order?.total?.serviceLevelDiscount || 0 | currency: usd }}
                  </p>
                </div>

                <!-- Line Item Discounts -->
                <div *ngIf="order?.total?.itemLevelDiscount" class="m-0 flex-start-center mb-2">
                  <p class="m-0 pl-24 s-summery-title">{{ 'line-item-discount' | translate }}</p>
                  <p class="b-bottom width-100p m-0"></p>
                  <p class="m-0 summary-content text-right">
                    {{ order?.total?.itemLevelDiscount || 0 | currency: usd }}
                  </p>
                </div>

                <ng-container *ngIf="order?.isDiscountItemEnabled">
                  <!-- Service discounts -->
                  <div *ngFor="let serviceDiscounts of serviceLevelDiscount" class="m-0 flex-start-center mb-2">
                    <p style="white-space: nowrap" class="m-0 pl-4 s-summery-title"
                      [innerHTML]="helperService.getLocalizationValue(currentLang,serviceDiscounts, 'title')">
                    </p>
                    <p class="b-bottom width-100p m-0"></p>
                    <p class="m-0 summary-content text-right">
                      {{ serviceDiscounts?.price || 0 | currency: usd }}
                    </p>
                  </div>

                  <!-- Order discounts -->
                  <div *ngFor="let orderDiscounts of order?.total?.orderDiscountItems"
                    class="m-0 flex-start-center mb-2">
                    <p style="white-space: nowrap" class="m-0 pl-4 s-summery-title"
                      [innerHTML]="helperService.getLocalizationValue(currentLang,orderDiscounts, 'name')">
                    </p>
                    <p class="b-bottom width-100p m-0"></p>
                    <p class="m-0 summary-content text-right">
                      {{ orderDiscounts?.discountCalcValue || 0 | currency: usd }}
                    </p>
                  </div>
                </ng-container>

                <ng-container *ngIf="!order?.isDiscountItemEnabled">
                  <div class="footer-invoice-row border-seprator">
                    <div class="invoice-row-item-left invoice-row-item-padding-4">{{ 'order-discount' | translate }}
                    </div>

                    <div class="invoice-row-item-right service-discount text-right invoice-row-item-padding-1">
                      {{ order?.total?.discountedAmount || 0 | currency: usd }}
                    </div>
                  </div>
                </ng-container>

                <!-- Subtotal -->
                <div class="m-0 flex-start-center mb-2">
                  <p class="m-0 pr-1 s-summery-title font-bold">{{ 'subtotal' | translate }}</p>
                  <p class="b-bottom width-100p m-0"></p>
                  <p class="m-0 summary-content text-right font-bold">
                    {{ order?.total?.afterDiscount || 0 | currency: usd }}
                  </p>
                </div>

                <!-- Passthrough Taxes -->
                <div class="m-0 flex-start-center mb-2" *ngIf="isPassThroughTaxEnable">
                  <p class="service-amount m-0 pr-1 s-summery-title font-bold">{{ 'passthrough-taxes' | translate }}</p>
                  <p class="b-bottom width-100p m-0"></p>
                  <p class="font-bold m-0 summary-content text-right">
                    <span *ngIf="!order?.passThroughTaxRates?.length || !isTaxDetailsBreakDown">
                      {{ order?.total?.passThroughTax | currency: usd }}
                    </span>
                  </p>
                </div>

                <!-- Passthrough Taxes details -->
                <ng-container *ngIf="isPassThroughTaxEnable && isTaxDetailsBreakDown">
                  <div class="m-0 flex-start-center mb-2"
                    *ngFor="let passThroughTaxRates of order?.passThroughTaxRates">
                    <p class="service-amount m-0 pl-30 s-summery-title">
                      {{ passThroughTaxRates?.name }}
                    </p>
                    <p class="b-bottom m-0" style="width: 55%"></p>
                    <p class="m-0 summary-content text-right">
                      {{ passThroughTaxRates?.amount || 0 | currency: usd }}
                    </p>
                  </div>
                </ng-container>

                <!-- Shop supplies -->
                <div *ngIf="order.total.shopFee && !order.isRoLevelFeeEnabled"
                  class="footer-invoice-row border-seprator">
                  <div class="invoice-row-item-left invoice-row-item-padding-2">{{ 'shop-supplies' | translate }}</div>
                  <div class="invoice-row-item-right text-right invoice-row-item-padding-1">
                    {{ order.total.shopFee | currency: usd }}
                  </div>
                </div>

                <!-- Tax -->
                <!-- if tax breakdown is on always show the tax percentage and amount -->
                <!-- <div class="m-0 flex-start-center mb-2" *ngIf="!isTaxDetailsBreakDown">
                <p class="m-0 pl-4 pr-1 s-summery-title">
                  Tax ({{ order?.total?.tax?.name }})
                </p>
                <p class="b-bottom width-100p m-0"></p>
                <p class="m-0 summary-content text-right">
                  {{ order?.total?.taxedAmount || 0 | currency : usd }}
                </p>
              </div> -->

                <!-- if tax breakdown is off only show the tax percentage and amount if the tax rates are not there -->
                <div class="m-0 flex-start-center mb-2">
                  <p class="service-amount m-0 pr-1 s-summery-title font-bold">
                    {{'sales-taxes' | translate}}
                    <ng-container *ngIf="!order?.taxValues?.taxRates?.length || !isTaxDetailsBreakDown"> ({{
                      order?.total?.tax?.name }}) </ng-container>
                  </p>
                  <p class="b-bottom width-100p m-0"></p>
                  <p class="font-bold m-0 summary-content text-right">
                    <span *ngIf="!order?.taxValues?.taxRates?.length || !isTaxDetailsBreakDown">
                      {{ order?.total?.taxedAmount || 0 | currency: usd }}
                    </span>
                  </p>
                </div>

                <!-- Tax Sub Items -->
                <ng-container *ngIf="isTaxDetailsBreakDown">
                  <div class="m-0 flex-start-center mb-2" *ngFor="let taxItem of order?.taxValues?.taxRates">
                    <p class="service-amount m-0 pl-30 s-summery-title">{{ taxItem?.name }}&nbsp;({{
                      taxItem?.salesTaxRate
                      }}%)</p>
                    <p class="b-bottom m-0" style="width: 55%"></p>
                    <p class="m-0 summary-content text-right" *ngIf="!data?.taxValues?.taxRates?.length">
                      {{ taxItem?.taxAmount || 0 | currency: usd }}
                    </p>
                  </div>
                </ng-container>

                <!-- Grand total -->
                <div class="m-0 flex-start-center mb-2">
                  <p class="m-0 pr-1 s-summery-title font-bold">{{ 'invoice-total' | translate }}</p>
                  <p class="b-bottom width-100p m-0"></p>
                  <p class="m-0 summary-content text-right font-bold">{{ order?.total?.grand || 0 | currency: usd }}</p>
                </div>

                <!-- Paid to date -->
                <div class="m-0 flex-start-center mb-2">
                  <p class="m-0 font-bold pr-1 s-summery-title">{{ 'paid-to-date' | translate }}</p>
                  <p class="b-bottom width-100p m-0"></p>
                  <p class="m-0 summary-content text-right font-bold">
                    {{ order?.total?.paid || 0 | currency: usd }}
                  </p>
                </div>

                <div class="m-0 flex-start-center mb-2" *ngIf="order?.total?.writeOffPayment">
                  <p class="m-0 font-bold pr-1 s-summery-title">Write-off</p>
                  <p class="b-bottom width-100p m-0"></p>
                  <p class="m-0 summary-content text-right font-bold">
                    {{ order?.total?.writeOffPayment || 0 | currency: usd }}
                  </p>
                </div>

                <div class="m-0 flex-start-center mb-2" *ngIf="order?.total?.overAgePayment">
                  <p class="m-0 font-bold pr-1 s-summery-title">Excess commision</p>
                  <p class="b-bottom width-100p m-0"></p>
                  <p class="m-0 summary-content text-right font-bold">-{{ order?.total?.overAgePayment || 0 | currency:
                    usd }}</p>
                </div>

                <!-- Remaining balance -->
                <!-- <div class="m-0 remaining-balance flex-between-center">
                <p class="m-0 pr-1 dynamicFont font-bold">Remaining&nbsp;balance</p>
                <p class="m-0 width-130 text-right dynamicFont font-bold">
                  {{ order?.total?.unpaid || 0 | currency : usd }}
                </p>
              </div> -->
                <div class="m-0 remaining-balance flex-between-center" *ngIf="isFinalizedAsThirdParty">
                  <p class="m-0 pr-1 dynamicFont font-bold">{{ 'remaining-balance' | translate }}</p>
                  <p class="m-0 width-130 text-right dynamicFont font-bold">
                    {{ (order?.total?.overAgePayment || 0) + order?.total?.unpaid - (order?.total?.writeOffPayment || 0)
                    || 0 | currency: usd }}
                  </p>
                </div>

                <div class="m-0 remaining-balance flex-between-center" *ngIf="!isFinalizedAsThirdParty">
                  <p class="m-0 pr-1 dynamicFont font-bold">{{ 'remaining-balance' | translate }}</p>
                  <p class="m-0 width-130 text-right dynamicFont font-bold">
                    {{ order?.total?.unpaid - (order?.total?.writeOffPayment || 0) || 0 | currency: usd }}
                  </p>
                </div>
              </div>
              <!-- End Order Summary -->

              <div *ngIf="!company?.appsettings?.isShowLineItemDisInPdf" class="ml-2 s-summary" #rightBar>
                <span *ngIf="serviceItemsBreakdown">
                  <!-- PTLO total -->
                  <div class="m-0 flex-start-center mb-2">
                    <p [ngClass]="{ 'service-amount': company?.appsettings?.isShowLineItemDisInPdf }"
                      class="m-0 pr-1 s-summery-title font-bold">{{ 'service-amount' | translate }}</p>
                    <p *ngIf="!company?.appsettings?.isShowLineItemDisInPdf" class="b-bottom width-100p m-0"></p>
                    <p class="m-0 summary-content text-right font-bold">{{ renderTotalPLTO() | currency: usd }}</p>
                  </div>

                  <!-- Part -->
                  <div class="m-0 flex-start-center mb-2">
                    <p class="m-0 pl-4 pr-1 s-summery-title">{{ 'part' | translate }}</p>
                    <p class="b-bottom width-100p m-0"></p>
                    <p class="m-0 summary-content text-right">{{ order?.total?.parts || 0 | currency: usd }}</p>
                  </div>

                  <!-- Labor -->
                  <div class="m-0 flex-start-center mb-2">
                    <p class="m-0 pl-4 pr-1 s-summery-title">{{ 'labor' | translate }}</p>
                    <p class="b-bottom width-100p m-0"></p>
                    <p class="m-0 summary-content text-right">{{ order?.total?.labor || 0 | currency: usd }}</p>
                  </div>

                  <!-- Tire storage -->
                  <div class="m-0 flex-start-center mb-2" *ngIf="order?.total?.tireStorage">
                    <p class="m-0 pl-4 pr-1 s-summery-title">{{ 'tire-storage' | translate }}</p>
                    <p class="b-bottom width-100p m-0"></p>
                    <p class="m-0 summary-content text-right">{{ order?.total?.tireStorage || 0 | currency: usd }}</p>
                  </div>

                  <!-- Tire -->
                  <div class="m-0 flex-start-center mb-2" *ngIf="order?.total?.tire">
                    <p class="m-0 pl-4 pr-1 s-summery-title">{{ 'tire' | translate }}</p>
                    <p class="b-bottom width-100p m-0"></p>
                    <p class="m-0 summary-content text-right">{{ order?.total?.tire || 0 | currency: usd }}</p>
                  </div>

                  <!-- Sublet -->
                  <div class="m-0 flex-start-center mb-2" *ngIf="order?.total?.sublet">
                    <p class="m-0 pl-4 pr-1 s-summery-title">{{ 'sublet' | translate }}</p>
                    <p class="b-bottom width-100p m-0"></p>
                    <p class="m-0 summary-content text-right">{{ order?.total?.sublet || 0 | currency: usd }}</p>
                  </div>

                  <!-- Other -->
                  <div class="m-0 flex-start-center mb-2" *ngIf="order?.total?.other">
                    <p class="m-0 pl-4 pr-1 s-summery-title">{{ 'other' | translate }}</p>
                    <p class="b-bottom width-100p m-0"></p>
                    <p class="m-0 summary-content text-right">{{ order?.total?.other || 0 | currency: usd }}</p>
                  </div>
                </span>

                <div *ngIf="company?.appsettings?.isShowLineItemDisInPdf" class="m-0 flex-start-center mb-2">
                  <p class="service-amount m-0 pr-1 s-summery-title font-bold">
                    {{ 'add' | translate }} {{ 'fees' | translate }}
                  </p>
                  <p class="b-bottom width-100p m-0"></p>
                  <p class="m-0 summary-content text-right font-bold">{{ order?.total?.hazmatFee || 0 | currency: usd }}
                  </p>
                </div>

                <ng-container *ngIf="company?.appsettings?.isShowLineItemDisInPdf">
                  <div *ngFor="let serviceFee of order?.total?.serviceLevelFeeItems" class="m-0 flex-start-center mb-2"
                    [hidden]="!order.total.hazmatFee">
                    <p style="white-space: nowrap" class="m-0 ml-4 pl-4 pr-1 s-summery-title">
                      {{ helperService.getLocalizationValue(currentLang,serviceFee, 'title')}}
                    </p>
                    <p class="b-bottom width-100p m-0"></p>
                    <p class="m-0 summary-content text-right">
                      {{ serviceFee?.subTotal || 0 | currency: usd }}
                    </p>
                  </div>
                </ng-container>

                <div *ngIf="company?.appsettings?.isShowLineItemDisInPdf" class="m-0 flex-start-center mb-2">
                  <p class="service-amount m-0 pr-1 s-summery-title font-bold">{{ 'less-discount' | translate }}</p>
                  <p class="b-bottom width-100p m-0"></p>
                  <p class="m-0 summary-content text-right font-bold">
                    {{ order?.total?.serviceLevelDiscount || 0 | currency: usd }}
                  </p>
                </div>

                <ng-container *ngIf="company?.appsettings?.isShowLineItemDisInPdf">
                  <div
                    [hidden]="(!order?.isDiscountItemEnabled || !serviceDiscounts?.netPrice) && !company?.appsettings?.isShowLineItemDisInPdf"
                    *ngFor="let serviceDiscounts of serviceLevelDiscount" class="m-0 flex-start-center mb-2">
                    <p style="white-space: nowrap" class="m-0 ml-4 pl-4 pr-1 s-summery-title"
                      [innerHTML]="helperService.getLocalizationValue(currentLang,serviceDiscounts, 'title')">
                    <p class="b-bottom width-100p m-0"></p>
                    <p class="m-0 summary-content text-right">
                      {{ serviceDiscounts?.netPrice || 0 | currency: usd }}
                    </p>
                  </div>
                </ng-container>

                <!-- Item discount -->
                <div [hidden]="!order?.total?.itemLevelDiscount" class="m-0 flex-start-center mb-2">
                  <p *ngIf="order?.isDiscountItemEnabled" class="m-0 pl-4 pr-1 s-summery-title">
                    {{ 'item-discount' | translate }}
                  </p>
                  <p class="b-bottom width-100p m-0"></p>

                  <p *ngIf="order?.isDiscountItemEnabled && order?.total?.itemLevelDiscount"
                    class="m-0 summary-content text-right">
                    {{ order?.total?.itemLevelDiscount || 0 | currency: usd }}
                  </p>
                </div>

                <!-- Service discount -->
                <ng-container *ngIf="!company?.appsettings?.isShowLineItemDisInPdf">
                  <div [hidden]="!order?.isDiscountItemEnabled" *ngIf="order?.total?.serviceLevelDiscount"
                    class="m-0 flex-start-center mb-2">
                    <p class="m-0 pl-4 pr-1 s-summery-title">{{ 'service-discount' | translate }}</p>
                    <p class="b-bottom width-100p m-0"></p>
                    <p class="m-0 summary-content text-right mr--4"></p>
                  </div>
                </ng-container>

                <!-- Service discounts -->
                <ng-container *ngIf="!company?.appsettings?.isShowLineItemDisInPdf">
                  <div [hidden]="!order?.isDiscountItemEnabled || !serviceDiscounts?.netPrice"
                    *ngFor="let serviceDiscounts of serviceLevelDiscount" class="m-0 flex-start-center mb-2">
                    <p style="white-space: nowrap" class="m-0 ml-4 pl-4 pr-1 s-summery-title"
                      [innerHTML]="helperService.getLocalizationValue(currentLang,serviceDiscounts, 'title')">
                    </p>
                    <p class="b-bottom width-100p m-0"></p>
                    <p class="m-0 summary-content text-right">
                      {{ serviceDiscounts?.netPrice || 0 | currency: usd }}
                    </p>
                  </div>
                </ng-container>

                <!-- Order discount -->
                <div class="m-0 flex-start-center mb-2" *ngIf="order?.total?.discountedAmount">
                  <p class="m-0 pl-4 pr-1 s-summery-title">{{ 'order-discount' | translate }}</p>
                  <p class="b-bottom width-100p m-0"></p>
                  <p class="m-0 summary-content text-right mr--4">
                    <span *ngIf="!order?.total?.orderDiscountItems?.length">
                      {{ order?.total?.discountedAmount || 0 | currency: usd }} </span>
                  </p>
                </div>

                <!-- Order discounts -->
                <div *ngFor="let orderDiscounts of order?.total?.orderDiscountItems" class="m-0 flex-start-center mb-2"
                  [hidden]="!order?.isDiscountItemEnabled || !orderDiscounts?.discountCalcValue">
                  <p style="white-space: nowrap" class="m-0 ml-4 pl-4 pr-1 s-summery-title"
                    [innerHTML]="helperService.getLocalizationValue(currentLang,orderDiscounts, 'name')">
                  </p>
                  <p class="b-bottom width-100p m-0"></p>
                  <p class="m-0 summary-content text-right">
                    {{ orderDiscounts?.discountCalcValue || 0 | currency: usd }}
                  </p>
                </div>

                <!-- Hazmat fee -->
                <ng-container *ngIf="!company?.appsettings?.isShowLineItemDisInPdf">
                  <div class="m-0 flex-start-center mb-2" *ngIf="order?.total?.hazmatFee">
                    <p class="m-0 pl-4 pr-1 s-summery-title">{{ 'total-service-level-fee' | translate }}</p>
                    <p class="b-bottom width-100p m-0"></p>
                    <p class="m-0 summary-content text-right">
                      <ng-container *ngIf="!order?.total?.serviceLevelFeeItems?.length">
                        {{ order?.total?.hazmatFee || 0 | currency: usd }}
                      </ng-container>
                    </p>
                  </div>
                </ng-container>

                <!-- hazmat fee items -->
                <ng-container *ngIf="!company?.appsettings?.isShowLineItemDisInPdf">
                  <div *ngFor="let serviceFee of order?.total?.serviceLevelFeeItems" class="m-0 flex-start-center mb-2"
                    [hidden]="!order.total.hazmatFee">
                    <p style="white-space: nowrap" class="m-0 ml-4 pl-4 pr-1 s-summery-title">{{
                      helperService.getLocalizationValue(currentLang,serviceFee, 'title') }}</p>
                    <p class="b-bottom width-100p m-0"></p>
                    <p class="m-0 summary-content text-right">
                      {{ serviceFee?.subTotal || 0 | currency: usd }}
                    </p>
                  </div>
                </ng-container>

                <!-- Ro Fee -->
                <div class="m-0 flex-start-center mb-2"
                  *ngIf="order?.isRoLevelFeeEnabled && order?.total?.preTaxFee?.length">
                  <p class="m-0 pl-4 pr-1 s-summery-title">{{ 'total' | translate }}&nbsp;{{ 'ro-fee' | translate }}</p>
                  <p class="b-bottom width-100p m-0"></p>
                  <p class="m-0 summary-content text-right">
                    <!-- {{ order?.total?.totalFee || 0 | currency: usd }} -->
                  </p>
                </div>

                <div *ngFor="let feeItem of order?.total?.preTaxFee" class="m-0 flex-start-center mb-2">
                  <p class="m-0 ml-4 pl-4 pr-1 s-summery-title"
                    [innerHTML]="helperService.getLocalizationValue(currentLang,feeItem, 'name')">
                  </p>
                  <p class="b-bottom width-100p m-0"></p>
                  <p class="m-0 summary-content text-right">
                    {{ feeItem?.feeCalcValue || 0 | currency: usd }}
                  </p>
                </div>

                <!-- Shop supplies -->
                <div class="m-0 flex-start-center mb-2" *ngIf="!order?.isRoLevelFeeEnabled && order?.total?.shopFee">
                  <p class="m-0 pr-1 s-summery-title">{{ 'shop-supplies' | translate }}</p>
                  <p class="b-bottom width-100p m-0"></p>
                  <p class="m-0 summary-content text-right">
                    {{ order?.total?.shopFee || 0 | currency: usd }}
                  </p>
                </div>

                <!-- Subtotal -->
                <div class="m-0 flex-start-center mb-2">
                  <p class="m-0 pr-1 s-summery-title font-bold">{{ 'subtotal' | translate }}</p>
                  <p class="b-bottom width-100p m-0"></p>
                  <p class="m-0 summary-content text-right font-bold">{{ order?.total?.afterDiscount || 0 | currency:
                    usd
                    }}</p>
                </div>

                <!-- Passthrough Taxes -->
                <div class="m-0 flex-start-center mb-2" *ngIf="isPassThroughTaxEnable">
                  <p class="service-amount m-0 pr-1 s-summery-title font-bold">{{ 'passthrough-taxes' | translate }}</p>
                  <p class="b-bottom width-100p m-0"></p>
                  <p class="font-bold m-0 summary-content text-right">
                    <span *ngIf="!order?.passThroughTaxRates?.length || !isTaxDetailsBreakDown">
                      {{ order?.total?.passThroughTax | currency: usd }}
                    </span>
                  </p>
                </div>

                <!-- Passthrough Taxes details -->
                <ng-container *ngIf="isPassThroughTaxEnable && isTaxDetailsBreakDown">
                  <div class="m-0 flex-start-center mb-2"
                    *ngFor="let passThroughTaxRates of order?.passThroughTaxRates">
                    <p class="service-amount m-0 pl-30 s-summery-title">
                      {{ passThroughTaxRates?.name }}
                    </p>
                    <p class="b-bottom m-0" style="width: 55%"></p>
                    <p class="m-0 summary-content text-right">
                      {{ passThroughTaxRates?.amount || 0 | currency: usd }}
                    </p>
                  </div>
                </ng-container>

                <!-- Tax -->
                <div class="m-0 flex-start-center mb-2">
                  <p class="m-0 pl-4 pr-1 s-summery-title">
                    Taxes
                    <ng-container *ngIf="!order?.taxValues?.taxRates?.length || !isTaxDetailsBreakDown">
                      <span *ngIf="!order?.taxValues?.taxRate">
                        ({{order?.total?.tax?.name }})
                      </span>
                      <span *ngIf="order?.taxValues?.taxRate">
                        ({{order?.taxValues?.taxRate}} %)
                      </span>
                    </ng-container>
                  </p>
                  <p class="b-bottom width-100p m-0"></p>
                  <p class="m-0 summary-content text-right">
                    <ng-container *ngIf="!order?.taxValues?.taxRates?.length || !isTaxDetailsBreakDown">
                      {{ order?.total?.taxedAmount || 0 | currency: usd }}
                    </ng-container>
                  </p>
                </div>

                <!-- Tax Sub Items -->
                <ng-container *ngIf="isTaxDetailsBreakDown">
                  <div class="m-0 flex-start-center mb-2" *ngFor="let taxItem of order?.taxValues?.taxRates">
                    <p class="m-0 pl-5 pr-1 s-summery-title">{{ taxItem?.name }}&nbsp;({{ taxItem?.salesTaxRate }}%)</p>
                    <p class="b-bottom m-0" style="width: 55%"></p>
                    <p class="m-0 summary-content text-right">{{ taxItem?.taxAmount || 0 | currency: usd }}</p>
                  </div>
                </ng-container>

                <!-- Grand total -->
                <div class="m-0 flex-start-center mb-2">
                  <p class="m-0 pr-1 s-summery-title font-bold">{{ 'grand-total' | translate }}</p>
                  <p class="b-bottom width-100p m-0"></p>
                  <p class="m-0 summary-content text-right font-bold">{{ order?.total?.grand || 0 | currency: usd }}</p>
                </div>

                <!-- Paid to date -->
                <div class="m-0 flex-start-center mb-2">
                  <p class="m-0 font-bold pr-1 s-summery-title">{{ 'paid-to-date' | translate }}</p>
                  <p class="b-bottom width-100p m-0"></p>
                  <p class="m-0 summary-content text-right font-bold">
                    {{ order?.total?.paid || 0 | currency: usd }}
                  </p>
                </div>

                <!-- write off -->
                <div class="m-0 flex-start-center mb-2" *ngIf="order?.total?.writeOffPayment">
                  <p class="m-0 font-bold pr-1 s-summery-title">{{ 'write-of' | translate }}</p>
                  <p class="b-bottom width-100p m-0"></p>
                  <p class="m-0 summary-content text-right font-bold">
                    {{ order?.total?.writeOffPayment || 0 | currency: usd }}
                  </p>
                </div>

                <!-- overages -->
                <div class="m-0 flex-start-center mb-2" *ngIf="order?.total?.overAgePayment">
                  <p class="m-0 font-bold pr-1 s-summery-title">{{ 'excess-commision' | translate }}</p>
                  <p class="b-bottom width-100p m-0"></p>
                  <p class="m-0 summary-content text-right font-bold">-{{ order?.total?.overAgePayment || 0 | currency:
                    usd }}</p>
                </div>

                <!-- Remaining balance -->
                <!-- <div class="m-0 remaining-balance flex-between-center">
                <p class="m-0 pr-1 dynamicFont font-bold">Remaining&nbsp;balance</p>
                <p class="m-0 width-130 text-right dynamicFont font-bold">
                  {{ order?.total?.unpaid || 0 | currency : usd }}
                </p>
              </div> -->
                <div class="m-0 remaining-balance flex-between-center" *ngIf="isFinalizedAsThirdParty">
                  <p class="m-0 pr-1 dynamicFont font-bold">{{ 'remaining-balance' | translate }}</p>
                  <p class="m-0 width-130 text-right dynamicFont font-bold">
                    {{ (order?.total?.overAgePayment || 0) + order?.total?.unpaid - (order?.total?.writeOffPayment || 0)
                    || 0 | currency: usd }}
                  </p>
                </div>

                <div class="m-0 remaining-balance flex-between-center" *ngIf="!isFinalizedAsThirdParty">
                  <p class="m-0 pr-1 dynamicFont font-bold">{{ 'remaining-balance' | translate }}</p>
                  <p class="m-0 width-130 text-right dynamicFont font-bold">
                    {{ order?.total?.unpaid - (order?.total?.writeOffPayment || 0) || 0 | currency: usd }}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <!-- New disclaimner position -->
          <div class="disclaimer-content-box-wrapper">
            <ng-container *ngIf="isPaymentSectionVisible">
              <p class="mb-0 text-justify pt-3 pb-3" [innerHTML]="disclaimerMsg"
                [ngClass]="{ 'd-none': !(order?.orderStatus === 'estimate' && disclaimer?.length) }"></p>

              <p *ngIf="company?.appsettings?.enableInvoiceSignature" class="mb-0 text-justify pt-3 pb-3"
                [ngClass]="{ 'd-none': !(order?.orderStatus === 'invoice' && invDisclaimer?.length) }"
                [innerHTML]="disclaimerMsg"></p>
            </ng-container>

            <!-- If payment table not visible then show disclaimer here -->
            <ng-container *ngIf="!isPaymentSectionVisible">
              <div
                *ngIf="(order?.orderStatus === 'estimate' && disclaimer?.length > 2000) || (order?.orderStatus === 'invoice' && invDisclaimer?.length > 2000)">
              </div>

              <!-- Estimate -->
              <ng-container *ngIf="order?.orderStatus === 'estimate'">
                <!-- If disclaimer greater then 2000 -->
                <ng-container *ngIf="disclaimer?.length > 2000">
                  <p class="mb-0 text-justify pb-3" [innerHTML]="disclaimerMsg"></p>
                </ng-container>

                <!-- If disclaimer less then 2000 -->
                <ng-container *ngIf="disclaimer?.length <= 2000">
                  <p class="mb-0 text-justify pb-3" [innerHTML]="disclaimer"></p>

                  <div class="signature flex-start-end mt-90 one">
                    <p class="mb-0 mr-2">{{ 'signature' | translate }}:</p>
                    <div class="user-sign width-50p mb-0">
                      <img *ngIf="order?.customerSig && showSign" class="user-sign-img"
                        src="data:image/png;base64,{{ order?.customerSig }}" alt="" />
                    </div>
                  </div>
                </ng-container>
              </ng-container>

              <!-- Invoice -->
              <ng-container *ngIf="order?.orderStatus === 'invoice'">
                <!-- If invoice disclaimer greater then 2000 -->
                <ng-container *ngIf="invDisclaimer?.length > 2000">
                  <p class="mb-0 text-justify pb-3" [innerHTML]="disclaimerMsg"></p>
                </ng-container>

                <!-- If invoice disclaimer less then 2000 -->
                <ng-container *ngIf="invDisclaimer?.length <= 2000">
                  <p class="mb-0 mr-2 pr-2 text-justify pb-3" [innerHTML]="invDisclaimer"></p>

                  <div
                    *ngIf="company?.appsettings?.isMultiLocationEnabled ? shopAppSettings?.enableInvoiceSignature : company?.appsettings?.enableInvoiceSignature"
                    class="signature flex-start-end mt-90 two">
                    <p class="mb-0 mr-2">Signature:</p>
                    <div class="user-sign width-50p mb-0">
                      <img *ngIf="order?.customerSigInvoice && showSign" class="user-sign-img"
                        src="data:image/png;base64,{{ order?.customerSigInvoice }}" alt="" />
                    </div>
                  </div>
                </ng-container>
              </ng-container>
            </ng-container>
            <!-- {{order?.orderStatus}} {{disclaimer?.length}} {{isPaymentSectionVisible}} -->
            <ng-container
              *ngIf="order?.orderStatus === 'estimate' && (disclaimer?.length > 2000 || isPaymentSectionVisible)">
              <div class="signature flex-start-end large-text-signature mt-90 clear">
                <p class="mb-0 mr-2">Signature:</p>
                <div class="user-sign width-50p mb-0">
                  <img class="user-sign-img" *ngIf="order?.customerSig && showSign"
                    src="data:image/png;base64,{{ order?.customerSig }}" alt="" />
                </div>
              </div>
              <div class="clearfix"></div>
              <div class="disclaimer-content align-self-start dynamicFont mt-20">
                <h6 class="font-700">Disclaimer:</h6>
                <p class="mb-0 text-justify pb-3" [innerHTML]="disclaimer"></p>
              </div>
            </ng-container>

            <!-- If invoice discalimer length is greater than 2000 or payment details is visible show invoice discalimer at bottom -->
            <ng-container
              *ngIf="order?.orderStatus === 'invoice' && (invDisclaimer?.length > 2000 || isPaymentSectionVisible)">
              <div class="signature flex-start-end mt-90 three"
                *ngIf="company?.appsettings?.isMultiLocationEnabled ? shopAppSettings?.enableInvoiceSignature : company?.appsettings?.enableInvoiceSignature"
                class="signature flex-start-end large-text-signature mt-90 clear">
                <p class="mb-0 mr-2">Signature:</p>
                <div class="user-sign width-sign mb-0">
                  <img *ngIf="order?.customerSigInvoice && showSign" class="user-sign-img"
                    src="data:image/png;base64,{{ order?.customerSigInvoice }}" alt="" />
                </div>
              </div>

              <div class="clearfix"></div>
              <div class="disclaimer-content align-self-start dynamicFont mt-20">
                <h6 class="font-700">Disclaimer:</h6>
                <p class="mb-0 text-justify pb-3" [innerHTML]="invDisclaimer"></p>
              </div>
            </ng-container>
          </div>
          <!-- End Payment Details -->
        </div>
      </tr>

      <!-- Disclaimers -->
      <!-- If disclaimer length is greater than 2000 or payment details is visible show disclaimer at bottom -->

      <!-- End Disclaimer section -->

      <span>&nbsp;</span>
      <br />

      <tr *ngIf="deferredServices.length > 0 && isDeferredServiceEnabled && isDeferredServiceVisibleOnInv">
        <div class="service-table-ins-header flex-between-center">
          <p class="my-0 font-weight-bold ml-12px width-100p deferred-service-heading">{{ 'deferred-service' | translate
            }}</p>
        </div>

        <span class="deferred-service-message">{{ 'below-are-the-services' | translate }}, {{ customer?.fullName }} {{
          'deferred-to-be-completed-in-the-future-these-services-are-not-part-of-the-invoice' | translate }}
        </span>
      </tr>

      <tr [hidden]="!isDeferredServiceEnabled || !isDeferredServiceVisibleOnInv"
        *ngFor="let service of deferredServices">
        <app-repair-order-item [isTreadDepthVisibleOnInvoice]="isTreadDepthVisibleOnInvoice"
          [isWarrantyNumberAddonEnabled]="isWarrantyNumberAddonEnabled"
          [isPartWarrantiesEnabled]="isPartWarrantiesEnabled" [currentLang]="currentLang"
          [isFlatRateSubItemVisibleToCust]="isFlatRateSubItemVisibleToCust"
          [isFlatRateSubItemQtyVisibleToCust]="isFlatRateSubItemQtyVisibleToCust"
          [isEnhancedTSEnabled]="isEnhancedTSEnabled"
          [isFlatRateSubItemDescVisibleToCust]="isFlatRateSubItemDescVisibleToCust" [service]="service"
          [displayExternalServiceNotes]="displayExternalServiceNotes" [total]="order.total"
          [serviceAuthLabel]="serviceAuthLabel" [isDeferredServiceEnabled]="isDeferredServiceEnabled"
          [appSettings]="company?.appsettings" [shopAppSettings]="shopAppSettings"
          [isTireStorage2Enabled]="isTireStorage2Enabled">
        </app-repair-order-item>
      </tr>

      <tr *ngIf="isCAStateComplianceEnabled && isDisplayAuthorizationLogs && !isrestrictAuthLogs">
        <app-repair-order-auth-logs *ngIf="pdfAuthHistory && pdfAuthHistory.length > 0" [timezone]="company.timezone"
          [pdfAuthHistory]="pdfAuthHistory"> </app-repair-order-auth-logs>
        <!-- <app-estimate-submission-history *ngIf="pdfAuthHistory && pdfAuthHistory.length > 0" [timezone]="company.timezone"
            [pdfAuthHistory]="pdfAuthHistory"> </app-estimate-submission-history> -->
      </tr>

      <ng-container *ngIf="isPartWarrantiesEnabled && isWarrantyNumberAddonEnabled && warrantyDisclaimer">
        <div class="pagebreak"></div>
        <p class="mb-0 mr-2 pr-2 text-justify pb-3" [innerHTML]="warrantyDisclaimer"></p>
      </ng-container>
      <ng-container *ngIf="isPartWarrantiesEnabled && isTireWarrantyPolicyEnabled && tireWarrantyPolicy">
        <div class="pagebreak"></div>
        <div class="tw-container">
          <div class="tw-header">
            {{ currentLang == 'en' ?
            'Congratulations! Your new tire purchase includes the Golden Guarantee!'
            : 'Félicitations! L\'achat de vos nouveaux pneus comprend la Garantie Or!'
            }}
          </div>
          <div class="tw-grid">
            <ng-container *ngFor="let tire of warrantiedTires">
              <div class="tw-grid-item">
                <p>{{ tire?.brand?.name || 'N/A' }} {{ tire?.model || 'N/A' }}</p>
                <p>{{ tire?.category?.name || tire?.category?.categoryName || 'N/A' }}</p>
                <p>{{ tire?.size || 'N/A' }}</p>
                <p>DOT: {{ tire.dotNumber || 'N/A'}}</p>
                <p>Part#: {{ tire?.code || 'N/A' }}</p>
                <p>Warranty#: {{ tire?.warranty?.warrantyNumber || 'N/A' }}</p>
              </div>
            </ng-container>
          </div>
        </div>
        <p class="mb-0 mr-2 pr-2 text-justify pb-3" [innerHTML]="tireWarrantyPolicy"></p>
      </ng-container>
    </tbody>
  </table>
</div>
